<template>
  <dr-wrapper v-if="isInEditorMode" v-bind="$props" v-on="wrapOn">
    <v-treeview :items="templateItems" open-all :open="templateItems" expand-icon="">
      <template v-slot:prepend="{ item }">
        <v-icon v-text="`mdi-${item.image}`">
        </v-icon>
      </template>
    </v-treeview>
	</dr-wrapper>
	<dr-launcher-component v-else-if="isVisible" v-bind="$props"></dr-launcher-component>
</template>

<script>
import mixin from '../../mixins/base-mixin'
import inputMixin from '../../mixins/input-mixin'
import widgetsWrapperMixin from '../../mixins/widgets-wrapper-mixin'

export default {
  name: 'dr-launcher',
  mixins: [mixin, inputMixin, widgetsWrapperMixin],
  computed: {
    templateItems() {
      return [
        {
          name: this.$t('vuetifyWidgets.dr-launcher.favorites'),
          image: 'folder-open',
          children: [
            {
              name: this.$t('vuetifyWidgets.dr-launcher.latest'),
              image: 'link',
              children: [
                {
                  name: this.$t('vuetifyWidgets.dr-launcher.myTasks'),
                  image: 'link'
                }
              ]
            },
            {
              name: this.$t('vuetifyWidgets.dr-launcher.frequent'),
              image: 'link'
            }
          ]
        }
      ]
    }
  }
}
</script>

<style>

</style>